import { Fragment } from "react";
import "./index.css";
import QRCode from "react-qr-code";
function QrParisPage() {
  const routeIOS: string = "https://milocalapp.web.app/ios-paris";
  const routeAndroid: string = "https://milocalapp.web.app/android-paris";

  return (
    <Fragment>
      <div className="help-paris-page">
        <div className="content mb-0">
          <img src="assets/img/paris/1.svg" alt="" />

          <div className="container-qr">
            <div className="qr-ios">
              <QRCode size={256} value={routeIOS} />
              <p>iOS</p>
            </div>

            <div className="qr-android">
              <QRCode size={256} value={routeAndroid} />
              <p>Android</p>
            </div>
          </div>

          <img className="mv-6" src="assets/img/paris/6.svg" alt="" />
          <img src="assets/img/paris/7.svg" alt="" />
        </div>
      </div>
    </Fragment>
  );
}

export default QrParisPage;
